import * as angular from 'angular';

const httpEndpointDefaultSetterDirective = function () {
  return {
    link: function (scope: angular.IScope) {
      const checkboxField = scope.dataSourceForm['data_source[custom_attributes][transport_mode]'];
      const httpEndpointField = scope.dataSourceForm['data_source[custom_attributes][http_endpoint]'];

      if (checkboxField) {
        // Don't enable watcher if there's no checkbox field
        scope.$watch('dataSource.transport_mode', function (newValue: string, _oldValue: string) {
          if (newValue) {
            if (httpEndpointField.$$element.context.value == '') {
              httpEndpointField.$$element.context.value = 'cliservice';
              httpEndpointField.$$element.focus();
            }
          }
        });
      }
    },
  };
};

angular.module('mode.components').directive('httpEndpointDefaultSetter', httpEndpointDefaultSetterDirective);
